// ナビ構成（外枠）。収支 / 運行 / Inp・Exp（連携）/ マスタ の4グループ。
export const NAV = [
  {
    group: '収支',
    items: [
      { id: 'dashboard', label: 'ダッシュボード', icon: '▦' },
      { id: 'operations', label: '運行実績×収支', icon: '◎' },
      { id: 'billing', label: '請求・支払', icon: '¥' },
      { id: 'chargesheet', label: '運賃お伺い書', icon: '書' },
    ],
  },
  {
    // 受付(intake)は配車・受注へ統合した（一覧にセグメントタブで仮受付/正式/配車済/全部を表示）。
    // #/intake への直接アクセスは router.js が dispatch へ内部リダイレクトする。
    // 設計: engineering-タクミ/docs/2026-08-25-受付配車受注統合-設計.md PR④
    group: '運行',
    items: [
      { id: 'dispatch', label: '配車・受注', icon: '▤' },
      { id: 'teiki', label: '定期便', icon: '⟳' },
    ],
  },
  {
    group: 'Inp/Exp',
    items: [
      { id: 'ingest', label: 'データ取込', icon: '⇩' },
      { id: 'dataexport', label: 'データ出力', icon: '⇧' },
      { id: 'tachograph', label: 'デジタコ（富士通）', icon: '◐', badge: '準備中' },
      { id: 'payroll', label: '給与・会計', icon: '計' },
    ],
  },
  {
    group: 'マスタ',
    items: [
      { id: 'vehicles', label: '車両台帳', icon: '▣' },
      { id: 'drivers', label: '乗務員', icon: '◍' },
      { id: 'customers', label: '得意先・単価', icon: '▥' },
    ],
  },
]

// NAV に出さない内部ルートの画面名（router.js の特例で描画されるビュー）。
// 無いとタイトルが前の画面のまま残る。
export const EXTRA_LABEL = { intake: '依頼主受付', invoice: '請求書（得意先向け）' }

export const NAV_IDS = NAV.flatMap((g) => g.items.map((i) => i.id))
export const NAV_LABEL = Object.fromEntries(NAV.flatMap((g) => g.items.map((i) => [i.id, i.label])))
